import { useState } from 'react';
import { downloadPdf } from '../agent';

export function DownloadButton({ quote, disabled }) {
  const [busy, setBusy] = useState(false);
  const [status, setStatus] = useState({ cls: '', text: '' });
  return (
    <>
      <button className="btn red" disabled={disabled || busy} onClick={() => downloadPdf(quote, { setDisabled: setBusy, setStatus })}>
        <svg viewBox="0 0 24 24"><path d="M12 4v11M7 10l5 5 5-5M5 20h14" /></svg>PDF'i indir
      </button>
      <div className={'dl-status' + (status.cls ? ' ' + status.cls : '')}>{status.text}</div>
    </>
  );
}
